import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { TextField } from "final-form-material-ui";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Field, Form } from "react-final-form";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import * as yup from "yup";
import { getVolumeTransferBiotemplate } from "../../../../api/sustainability/storage/outgoing-transaction/getBiotemplates";
import ButtonRounded from "../../../../components/ButtonRounded";
import makeValidate from "../../../../components/form/makeValidate";
import KeyboardDatePicker from "../../../../components/inputs/KeyboardDatePicker";
import ModalInfo from "../../../../components/modal/ModalInfo";
import useModal from "../../../../components/modal/useModal";
import SmartSelect from "../../../../components/SmartSelect";
import RequiredAsterisk from "../../../../components/texts/RequiredAsterisk";
import ToggleButton from "../../../../components/ToggleButton";
import { getAppVariables } from "../../../../reducers/settings/app_variables";
import { IAppVariables } from "../../../../types/ApiInterfaces";
import VolumeTransEditableTable from "./VolumeTransEditableTable";
import ModalSaveVolumeTransfer from "./ModalSaveVolumeTransfer";
import parseAndFormat from "../../../../components/texts/parseAndFormat";
import parseToFloat from "../../../../components/texts/parseToFloat";
import {useBiofuelVolumeStyles} from "../../../../common/styles/RawMaterial";

const useStyles = useBiofuelVolumeStyles;

interface Props {
  app_variables: IAppVariables;
}

const BiofuelVolumeTransferView: React.FC<Props> = ({ app_variables }) => {
  const [showSaveModal, setShowSaveModal] = useState<boolean>(false);
  const [canSubmit, setCanSubmit] = useState<boolean>(false);
  const [transfer_volume, setTransferVolume] = useState<any>(null);
  const [headData, setHeadData] = useState<any>(null);
  const [tableData, setTableData] = useState<any>(null);
  const [editedTableData, setEditedTableData] = useState<any>(null);
  const [infoMessage, SetInfoMessage] = useState("");
  const [serialNumber, setSerialNumber] = useState<any>(null);

  const { openModalId, toggle } = useModal();
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  const openModal = (id: string, text: string) => {
    if (id === "info") { SetInfoMessage(text); }
    toggle(id);
  };

  const closeModal = () => {
    SetInfoMessage("");
    toggle();
  };

  const openSaveModal = () => {
    triggerTableSubmit();

  };
  const closeSaveModal = () => {
    setEditedTableData(null);
    setShowSaveModal(false);
  };

  const triggerTableSubmit = () => {
    if (document) {
      const volumeTransferTableForm = document.getElementById(
        "biofuel_volume_transfer_table_form"
      );
      if (volumeTransferTableForm) {
        volumeTransferTableForm.dispatchEvent(
          new Event("submit", { cancelable: true })
        );
      }
    }
  };

  const validationSchema = yup.object({
    transfer_volume: yup
      .number()
      .max(99999999999999)
      .typeError("Please enter a number.")
      .required(),
    biofuel_type: yup.string().required(),
    storage_terminal_out: yup.string().required(),
    storage_terminal_in: yup.string().required(),
    transfer_date: yup.string().required(),
  });

  const handleChooseProducts = async (values: any) => {
    setHeadData({ ...values });
    setTransferVolume(values.transfer_volume);
    const transferValues = {
      transfer_volume: parseToFloat(values.transfer_volume),
      biofuel_type: values.biofuel_type,
      storage_terminal_out: values.storage_terminal_out,
      storage_terminal_in: values.storage_terminal_in,
      transfer_date: moment(values.transfer_date).format("YYYY-MM-DD"),
    };
    const response = await getVolumeTransferBiotemplate(transferValues);
    if (response) {
      setTableData(response.biotemplates);
      setSerialNumber(response.serial_number);
    }
  };

  const validateTableData = (values: any) => {
    console.log(values);
  };

  const onFormChange = (formState: any) => {
    const data: any = formState.values;
    const vol = data.transfer_volume == null ? data.transfer_volume : data.transfer_volume.replace(/[^0-9.,]/g, "").replace(/,/g, ".");
    data.transfer_volume = parseAndFormat(vol, 0, true);
    setTransferVolume(parseToFloat(data.transfer_volume));
    setHeadData(data);
  };

  const handleTableData = (values: any) => {
    if (values && Array.isArray(values.biotemplates)) {
      const filteredValues = values.biotemplates.filter(
        (data: any) => data.moved_quantity
      );
      if (filteredValues.length > 0) {
        let total = 0;
        for (let i = 0; i <
          filteredValues.length; i += 1) {
          total += parseToFloat(filteredValues[i].moved_quantity);
          filteredValues[i].serial_number = parseInt(serialNumber) + i;
        }
        if (total !== parseToFloat(transfer_volume)) {
          openModal(
            "info",
            "Allocated quantity must be matched with given volume"
          );
          return false;
        }

        const bioValues = filteredValues.map((data: any) => ({
          id: data.id,
          serialNumber: data.serial_number,
          quantity: data.moved_quantity,
          pos_date: moment(new Date()).format("YYYY-MM-DD"),
          shipment_sale_nomination: data.shipment_sale_nomination,
          b_l_date: data.b_l_date,
          vessel: data.vessel,
          storage_terminal: data.storage_terminal,
          biofuel_type: data.biofuel_type,
          raw_material: data.raw_material,
          raw_material_origin: data.raw_material_origin,
          certificate: data.certificate,
          site_start: data.site_start,
          eec: data.eec,
          el: data.el,
          ep: data.ep,
          etd: data.etd,
          eu: data.eu,
          esca: data.esca,
          eccs: data.eccs,
          eccr: data.eccr,
          eee: data.eee,
          etot: data.etot,
          reduction_in_climate_emission: data.reduction_in_climate_emission,
        }));

        if (bioValues.length > 0) {
          setEditedTableData(bioValues);
        }
        setShowSaveModal(true);
      } else {
        openModal(
          "info",
          "Please allocated quantity before submit"
        );
      }
    }
  };

  const haveTableData = tableData !== null;
  const [initialValues] = useState(
      headData || {
        transfer_volume: null,
        biofuel_type: "",
        storage_terminal_in: "",
        storage_terminal_out: "",
        transfer_date: new Date(),
        status: "completed",
      }
  );
  useEffect(() => {
    let isMounted = true;
    if (isMounted) { // Only update the state if the component is still mounted
      dispatch(getAppVariables());
    }
    return () => { // Add a cleanup function to cancel any ongoing tasks
      isMounted = false;
    };
  }, []);
  return (
    <div className={classes.root}>
      <Form
        onSubmit={handleChooseProducts}
        validate={values => makeValidate({...values, transfer_volume: parseToFloat(values.transfer_volume) }, validationSchema)}
        initialValues={initialValues}
      >
        {({ handleSubmit, submitting, pristine, hasValidationErrors, form }) => {
          // eslint-disable-next-line
          useEffect(() => {
          const unsubscribe = form.subscribe(onFormChange, { values: true });
          return unsubscribe;

        }, [form]);
          return (
          <form onSubmit={handleSubmit} noValidate>
            <Grid container justify="space-between" alignItems="center">
              <Grid item>
                <Typography variant="h2" className={classes.h2}>
                  Biofuel Volume Transfer
                </Typography>
              </Grid>
              <Grid item>
                <ButtonRounded
                  variant="outlined"
                  color="default"
                  className={classes.btn}
                  onClick={() => {
                    form.reset();
                    setTableData(null);
                    setEditedTableData(null);
                    setHeadData(null);
                    setCanSubmit(false);
                    setTransferVolume(null);
                    setSerialNumber(null);
                  }}
                >
                  reset
                </ButtonRounded>
                <ButtonRounded
                  variant="outlined"
                  color="default"
                  className={classes.btn}
                  onClick={() => history.goBack()}
                >
                  cancel
                </ButtonRounded>
                <ButtonRounded
                  variant="contained"
                  color="primary"
                  className={classes.btn}
                  onClick={openSaveModal}
                  disabled={!canSubmit}
                >
                  save
                </ButtonRounded>
              </Grid>
            </Grid>

            <div className={classes.topCard}>
              <Grid
                container
                spacing={2}
                alignItems="center"
                className={classes.cardContent}
              >
                <Grid item xs className={classes.toggleContainer}>
                  <ToggleButton
                    labels={["Completed", "Blocked"]}
                    size="small"
                    handleChange={() => {}}
                    disabled
                  />
                </Grid>
                <Grid item xs>
                  <Typography variant="body2">
                    Biofuel Type <RequiredAsterisk />
                  </Typography>
                  <Field name="biofuel_type">
                    {props => (
                      <SmartSelect
                        {...props.input}
                        fullWidth
                        displayEmpty
                        type={"biofuel_type"}
                        disabled={haveTableData}
                      />
                    )}
                  </Field>
                </Grid>
                <Grid item xs>
                  <Typography variant="body2">
                    Transfer Volume (L) <RequiredAsterisk />
                  </Typography>
                  <Field
                    component={TextField}
                    name="transfer_volume"
                    variant="outlined"
                    placeholder="0,00"
                    fullWidth
                    className={classes.fields}
                    disabled={haveTableData}
                  />
                </Grid>
                <Grid item xs>
                  <Typography variant="body2">
                    Storage Terminal Out <RequiredAsterisk />
                  </Typography>
                  <Field name="storage_terminal_out">
                    {props => (
                      <SmartSelect
                        {...props.input}
                        fullWidth
                        displayEmpty
                        type={"storage_terminals"}
                        disabled={haveTableData}
                      />
                    )}
                  </Field>
                </Grid>
                <Grid item xs>
                  <Typography variant="body2">
                    Storage Terminal In <RequiredAsterisk />
                  </Typography>
                  <Field name="storage_terminal_in">
                    {props => (
                      <SmartSelect
                        {...props.input}
                        fullWidth
                        displayEmpty
                        type={"storage_terminals"}
                        disabled={haveTableData}
                      />
                    )}
                  </Field>
                </Grid>
                <Grid item xs>
                  <Typography variant="body2">
                    Transfer Date <RequiredAsterisk />
                  </Typography>
                  <Field name="transfer_date">
                    {({ input, meta }) => (
                      <KeyboardDatePicker
                        {...input}
                        inputVariant="outlined"
                        format="YYYY-MM-DD"
                        className={classes.fields}
                        disabled={haveTableData}
                        placeholder={moment().format("YYYY-MM-DD")}
                        value={input.value ? input.value : null}
                        onChange={(value: any) => {
                          input.onChange(moment(new Date(value)).format("YYYY-MM-DD"));
                        }}
                      />
                    )}
                  </Field>
                </Grid>
              </Grid>
            </div>

            <Card>
              <CardContent className={classes.cardTable}>
                <VolumeTransEditableTable
                  data={tableData ? tableData : null}
                  transfer_volume={parseToFloat(transfer_volume)}
                  disabledChooseProducts={
                    submitting || pristine || hasValidationErrors
                  }
                  handleChooseProducts={handleSubmit}
                  onSubmit={handleTableData}
                  canSubmit={canSubmit}
                  setCanSubmit={setCanSubmit}
                />
              </CardContent>
            </Card>
          </form>
        ); }}
      </Form>
      {headData && (
        <ModalSaveVolumeTransfer
          data={editedTableData}
          generalData={headData}
          open={showSaveModal}
          onClose={closeSaveModal}
        />
      )}
      <ModalInfo
        text={infoMessage}
        open={openModalId === "info"}
        onClose={closeModal}
      />
    </div>
  );
};

export default BiofuelVolumeTransferView;
